import { ColorPickerField } from '../components/ColorPickerField';

const horizontalLinePlugin: any = {
  Renderer: ({ data }: any) => (
    <div
      className="horizontal-line"
      style={{
        margin: '5px 0',
        borderBottom: `1px solid ${
          data?.color ? data?.color : 'rgba(204,204,204,1)'
        }`,
      }}
    />
  ),

  id: 'horizontalLinePlugin',
  title: 'Horizontal Line',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        color: {
          type: 'string',
          default: 'rgba(204,204,204,1)',
          uniforms: {
            component: ColorPickerField,
            label: 'Line Color:',
          },
        },
      },
    },
  },
};

export default horizontalLinePlugin;
